module.exports = __webpack_public_path__ + "static/media/shieldRoundPykes.2448c545.jpg";